import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import CashInflow from "../CashInflow/CashInflow";
import Income from "../Income/Income";
import Ledger from "../Ledger/Ledger";
import Trial from "../TrialBalance/TrialBalance";
import SharedTooltip from "../../components/Shared/SharedTooltip";
// import VatReport from "../Vat Report/VatReport";
import PurchaseVatReport from "../Vat Report/PurchaseVatReport";
import BalanceSheetPage from "../BalanceSheet/BalanceSheetPage";
import VatReturnReport from "../VatReturnReport/VatReturnReport";
import AccountStatementMain from "../AccountStatement/AccountStatementMain";
import CustomTabs from "../../components/Shared/CustomTabs";

export default function ReportMain() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTabIndex, setActiveTabIndex] = useState(
    location.state?.activeTabIndex ?? 0,
  );

  useEffect(() => {
    if (location.state?.activeTabIndex != null) {
      setActiveTabIndex(location.state.activeTabIndex);
      // Clear state so refreshing doesn't reuse it
      navigate(location.pathname, {
        replace: true,
        state: { ...location.state, activeTabIndex: null },
      });
    }
  }, []);

  const reportTabs = [
    { name: "BalanceSheet", content: () => <BalanceSheetPage /> },
    // {name:"CashFlow", content: () => <CashInflow />},
    { name: "IncomeStatement", content: () => <Income /> },
    { name: "accountStatement", content: () => <AccountStatementMain /> },
    { name: "Ledger", content: () => <Ledger /> },
    {
      name: "PreTrialBalance",
      content: () => (
        <Trial
          reportName="PreTrialBalance"
          reportTitle="Pre Trial Balance Report"
          endpoint="reports/getTrialBalanceReport"
        />
      ),
    },
    { name: "TrialBalance", content: () => <Trial /> },
    { name: "Purchase VAT Report", content: () => <PurchaseVatReport /> },
    // { name: "VAT Report", content: () => <VatReport /> },
    { name: "VAT Return Report", content: () => <VatReturnReport /> },
  ];
  return (
    <div>
      {/* <div className='flex justify-between flex-col gap-3 sm:gap-0 sm:flex-row mb-3'>
          <SharedTooltip
            content={t('Keep_track_of_your_reports')}
            position='left'
            id='report'
          />
          <span
            data-tooltip-id='report'
            className='font-semibold text-black/70 text-xl mt-2 '
          >
            {t('reports')}
          </span>
        </div> */}
      <div className="h-full">
        <CustomTabs
          tabs={reportTabs}
          activeTabIndex={activeTabIndex}
          setActiveTabIndex={setActiveTabIndex}
          className="report-tabview"
        />
      </div>
    </div>
  );
}
